import * as PIXI from 'pixi.js';
import { Howl } from 'howler';
import Config from './Config';
import * as Sounds from './Sounds';

export default class Obstacle extends PIXI.Container {
  constructor(x) {
    super();

    this.elapsedTime = 0;
    this.sprite = null;
    this.initialX = x;

    this.position.set(x, Config.GAME_HEIGHT - Config.GROUND_HEIGHT);
    this.type = Math.floor(Math.random() * 5);

    this.obstacleSpriteOffsetX = [-10, 5, 0, 0, 0][this.type];
    this.obstacleSpriteOffsetY = [70, 40, 60, 65, 50][this.type];
    this.obstacleWidth = [80, 64, 64, 100, 90][this.type];
    this.obstacleHeight = [220, 150, 250, 150, 150][this.type];

    this.onResourcesLoaded();
  }

  onResourcesLoaded() {
    this.sprite = new PIXI.Sprite(PIXI.Loader.shared.resources[`obstacle${this.type}`].texture);
    this.sprite.anchor.set(0.5, 1);
    this.sprite.position.set(this.obstacleSpriteOffsetX, this.obstacleSpriteOffsetY);

    this.addChild(this.sprite);

    // this.graphics = new PIXI.Graphics();
    // this.graphics.beginFill(0xff0000);
    // this.graphics.drawRect(-this.obstacleWidth / 2, -this.obstacleHeight, this.obstacleWidth, this.obstacleHeight);
    // this.graphics.endFill();
    // this.addChild(this.graphics);
  }

  update(dt, [
    background,
    foreground,
    player,
    ground,
    ...treasures
  ]) {
    const playerOnscreenX = Config.PLAYER_ONSCREEN_POSITION * Config.GAME_WIDTH;

    this.position.x = this.initialX - player.positionX;

    if (player.isDead) return;
    if (player.isInvulnerable) return;

    const closestX = Math.max(this.position.x - this.obstacleWidth / 2, Math.min(playerOnscreenX, this.position.x + this.obstacleWidth / 2));
    const closestY = Math.max(this.position.y - this.obstacleHeight, Math.min(player.position.y, this.position.y));

    // Calculate the distance between the player's center and this closest point
    const distanceX = playerOnscreenX - closestX;
    const distanceY = player.position.y - closestY;

    // Calculate the distance squared (to avoid the square root for performance reasons)
    const distanceSquared = distanceX * distanceX + distanceY * distanceY;

    // Check if the distance squared is less than the player's radius squared, indicating a collision
    const isColliding = distanceSquared < (Config.PLAYER_RADIUS * Config.PLAYER_RADIUS);

    if (isColliding) {
      Sounds.hit.play();
      player.onObstacleCollision();
    }
  }
}
